import noDataImg from './assets/noData.jpeg';
import { Placeholder } from './Placeholder';

export const DefaultPlaceholder = () => (
    <Placeholder picture={noDataImg} text="Monkey is sad because there is no data to display." />
);
